import { TableColumn, StatusBadge } from "@vilocnv/allsetra-core";

//
// TABLE HEADERS
//
export const ACCOUNTS_TABLE_COLUMNS = (translator: any): TableColumn<any>[] => [
  {
    name: translator("tableHeading.name", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => row?.accountName,
    sortable: true,
    sortField: "accountName"
  },
  {
    name: translator("tableHeading.usersCount", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => row?.usersCount,
    sortable: true
  },
  {
    name: translator("tableHeading.linkedObjects", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) =>
      row?.accountLinkedObjects?.reduce(
        (accumulator: any, currentValue: any) => {
          return accumulator + (currentValue.total || 0);
        },
        0
      )
  },
  {
    name: translator("tableHeading.status", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: any) => (
      <StatusBadge isDeactivated={row?.isAccountDeactivated} />
    ),
    sortable: true,
    sortField: "isAccountDeactivated"
  }
];

export const ACCOUNTS_LINEAR_TABLE_COLUMNS = (
  translator: any
): TableColumn<any>[] => [
  {
    name: "№",
    selector: (row: any) => {
      return row.rowNumber || "N/A";
    },
    width: "50px"
  },
  {
    name: translator("tableHeading.user", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => row?.name || "N/A",
    sortable: true,
    sortField: "name",
    width: "90%"
  }
];
